import { defineStore } from 'pinia'

/**
 * Bloque la navigation (layout) pendant une invocation gacha en cours.
 */
export const useInvocationLockStore = defineStore('invocationLock', {
  state: () => ({
    /** True pendant doPull (sync avec isPulling sur /gacha) */
    active: false,
  }),
  actions: {
    setActive(v: boolean) {
      this.active = v
    },
  },
})
